import { clientApiCall } from "./apiCallWrapper";
import type {
  ManagerHtmlByProductId,
  ManagerInstallByProductId,
  ManagerInstallCorrection,
  ManagerInstallPriceResponse,
  ManagerProductId,
  ManagerScriptsParams,
  ManagerScriptsResponse,
} from "./types/manager";

function productIdsParam(ids: ManagerProductId[]): string {
  return ids.join(",");
}

/** Клиентский API данных, доступных менеджерам и администраторам. */
export default (_axios: any, config: any) => ({
  getCatalogManagerComments(
    ids: ManagerProductId[],
  ): Promise<ManagerHtmlByProductId | null> {
    return clientApiCall<ManagerHtmlByProductId>(
      `${config.API_URL}/catalog_v2/getManagerComments`,
      {
        api: "manager.getCatalogManagerComments",
        params: { ids: productIdsParam(ids) },
      },
    );
  },

  getManagerInstall(
    ids: ManagerProductId[],
  ): Promise<ManagerInstallByProductId | null> {
    return clientApiCall<ManagerInstallByProductId>(
      `${config.API_URL}/catalog_v2/getManagerInstall`,
      {
        api: "manager.getManagerInstall",
        params: { ids: productIdsParam(ids) },
      },
    );
  },

  getManagerDelivery(
    productIds: ManagerProductId[],
    time = "",
    weekday = "",
    reset = false,
  ): Promise<ManagerHtmlByProductId | null> {
    return clientApiCall<ManagerHtmlByProductId>(
      `${config.API_SERVER_URL}/client/manager/getManagerDelivery`,
      {
        api: "manager.getManagerDelivery",
        params: {
          productIds: productIdsParam(productIds),
          time,
          weekday,
          reset,
        },
      },
    );
  },

  getManagerDeliveryTk(
    productIds: ManagerProductId[],
    time = "",
    weekday = "",
    reset = false,
  ): Promise<ManagerHtmlByProductId | null> {
    return clientApiCall<ManagerHtmlByProductId>(
      `${config.API_SERVER_URL}/client/manager/getManagerDeliveryTk`,
      {
        api: "manager.getManagerDeliveryTk",
        params: {
          productIds: productIdsParam(productIds),
          time,
          weekday,
          reset,
        },
      },
    );
  },

  getManagerInstallPrice(
    mark: string,
    model: string,
    kuzov: string,
    reset = false,
  ): Promise<ManagerInstallPriceResponse | null> {
    return clientApiCall<ManagerInstallPriceResponse>(
      `${config.API_SERVER_URL}/client/manager/getManagerInstallPrice`,
      {
        api: "manager.getManagerInstallPrice",
        params: { mark, model, kuzov, reset },
      },
    );
  },

  getManagerInstallCorrection(
    reset = false,
  ): Promise<ManagerInstallCorrection[] | null> {
    return clientApiCall<ManagerInstallCorrection[]>(
      `${config.API_SERVER_URL}/client/manager/getManagerInstallCorrection`,
      {
        api: "manager.getManagerInstallCorrection",
        params: { reset },
      },
    );
  },

  getManagerScripts(
    params: ManagerScriptsParams,
    reset = false,
  ): Promise<ManagerScriptsResponse | null> {
    return clientApiCall<ManagerScriptsResponse>(
      `${config.API_SERVER_URL}/client/manager/getManagerScripts`,
      {
        api: "manager.getManagerScripts",
        params: { ...params, reset },
      },
    );
  },

  getManagerComments(
    ids: ManagerProductId[],
  ): Promise<ManagerHtmlByProductId | null> {
    return clientApiCall<ManagerHtmlByProductId>(
      `${config.API_SERVER_URL}/client/manager/getManagerComments`,
      {
        api: "manager.getManagerComments",
        params: {
          ids: productIdsParam(ids),
          v: Date.now(),
        },
      },
    );
  },
});
